// Metatags da página. O servidor (enb-api/src/seo) já entrega o index.html com elas preenchidas;
// aqui só atualizamos as mesmas tags durante a navegação, seguindo as mesmas regras do servidor.

function setTag(selector, value) {
  const el = document.head.querySelector(selector)
  if (el) el.setAttribute(el.tagName === 'LINK' ? 'href' : 'content', value || '')
}

// keywords vem no index.html (__META_KEYWORDS__); cria a tag se não existir (ex.: index.html antigo em cache)
function setKeywords(value) {
  let el = document.head.querySelector('meta[name="keywords"]')
  if (!el) {
    if (!value) return
    el = document.createElement('meta')
    el.setAttribute('name', 'keywords')
    document.head.appendChild(el)
  }
  el.setAttribute('content', value || '')
}

export function setMeta({ title, description, image, url, keywords } = {}) {
  if (title !== undefined) {
    document.title = title
    setTag('meta[property="og:title"]', title)
  }
  if (description !== undefined) {
    setTag('meta[name="description"]', description)
    setTag('meta[property="og:description"]', description)
  }
  if (image !== undefined) setTag('meta[property="og:image"]', image)
  if (keywords !== undefined) setKeywords(keywords)
  if (url !== undefined) {
    setTag('meta[property="og:url"]', url)
    setTag('link[rel="canonical"]', url)
  }
}

// Remove HTML da descrição e limita ao tamanho usado pelos buscadores
function toDescription(texto) {
  let limpo = String(texto || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim()
  return limpo.length > 160 ? limpo.substring(0, 157).trim() + '...' : limpo
}

export function defaultMeta(empresa) {
  return {
    title: empresa.metatitle || empresa.nome_empresa || 'enb',
    description: empresa.metadescription || '',
    image: empresa.logo ? `${window.location.origin}/og/logo` : '',
    url: window.location.origin + window.location.pathname,
    keywords: ''
  }
}

// SEO salvo como preferência (comp SeoPaginaPrincipal em /loja e /site, SeoFrenteLoja em / com a
// frente de loja ativa, SeoLogin em /login);
// campo vazio mantém o padrão da loja
export function seoPrefMeta(prefes, comp) {
  const seo = (prefes && prefes[comp]) || {}
  const meta = { keywords: seo.palavrachave || '' }
  if (seo.titulo) meta.title = seo.titulo
  if (seo.descricao) meta.description = seo.descricao
  // a imagem salva é um arquivo em ./static da API; base64 ainda não salvo não serve para og:image
  if (seo.img && seo.img.indexOf('base64,') === -1) {
    meta.image = `${window.location.origin}/${encodeURIComponent(seo.img.replace(/^\/+/, ''))}`
  }
  return meta
}

export function produtoMeta(empresa, produto) {
  return {
    title: `${produto.name} | ${empresa.nome_empresa}`,
    description: toDescription(produto.descricao) || empresa.metadescription || '',
    image: produto.img && produto.img.length ? `${window.location.origin}/og/produto/${produto.id}` : undefined
  }
}

// Categoria: SEO da preferência SeoCategoria<id> por cima do título padrão
export function categoriaMeta(empresa, categoria, prefes) {
  return { title: `${categoria.name} | ${empresa.nome_empresa}`, ...seoPrefMeta(prefes, 'SeoCategoria' + categoria.id) }
}

// Mixin: o componente define o computed `metaPage` (ou null) e ele é aplicado
// depois do router.afterEach do main.js, que volta tudo para o padrão da loja
export default {
  watch: {
    metaPage: { handler: 'applyMetaPage', immediate: true, flush: 'post' },
    $route: { handler: 'applyMetaPage', flush: 'post' }
  },
  methods: {
    applyMetaPage () {
      if (this.metaPage) setMeta(this.metaPage)
    }
  }
}
